import * as fromDatatype from "../datatype-library/index";


export interface bl_del_job_custom_status_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    file_guid: fromDatatype.GuidDataFieldInterface;
    file_name: fromDatatype.VarcharDatatypeInterface;
    file_size: fromDatatype.NumericDatatypeInterface;
    import_format: fromDatatype.VarcharDatatypeInterface;
    obj_type: fromDatatype.VarcharDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    process_status: fromDatatype.VarcharDatatypeInterface;
    error_message: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}


export class bl_del_job_custom_status_hdr_RowClass
    implements bl_del_job_custom_status_hdr_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        code: fromDatatype.VarcharDatatypeInterface;
        name: fromDatatype.VarcharDatatypeInterface;
        descr: fromDatatype.TextDatatypeInterface;
        remarks: fromDatatype.VarcharDatatypeInterface;
        file_guid: fromDatatype.GuidDataFieldInterface;
        file_name: fromDatatype.VarcharDatatypeInterface;
        file_size: fromDatatype.NumericDatatypeInterface;
        import_format: fromDatatype.VarcharDatatypeInterface;
        obj_type: fromDatatype.VarcharDatatypeInterface;
        reference_no: fromDatatype.VarcharDatatypeInterface;
        process_status: fromDatatype.VarcharDatatypeInterface;
        error_message: fromDatatype.VarcharDatatypeInterface;
        property_json: fromDatatype.JsonDatatypeInterface;
        namespace: fromDatatype.VarcharDatatypeInterface;
        acl_config: fromDatatype.JsonDatatypeInterface;
        acl_policy: fromDatatype.JsonDatatypeInterface;
        status: fromDatatype.StatusDataFieldInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VrsnDataFieldInterface;

}